import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbAsmblAccDefSelect from './AsmblAccDefSelect';
Vue.regist(SwbAsmblAccDefSelect);

// 组装件定义选择
export function showAsmblAccDefSelectDlg(params, callback) {
    let checkIds = params["checkIds"] || [];
    let filter = params["filter"] || {};
    let checkBox = params["checkBox"] == null ? true : params["checkBox"];
    let needDisabled = params["needDisabled"] == null ? false : params["needDisabled"];
    let theDlg = Vue.$showDialog({
        title: "组装件定义 - 选择",
        width: -400,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-asmbl-acc-def-list-select :checkIds="checkIds" :filter="filter" :checkBox="checkBox" :needDisabled="needDisabled" ref="swb_asmbl_acc_def_list_select"></swb-asmbl-acc-def-list-select>',
        data: {
            checkIds: checkIds,
            filter: filter,
            checkBox: checkBox,
            needDisabled: needDisabled
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asmbl_acc_def_list_select.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}
import SwbMerchtDevcDefRelMack from './MerchtDevcDefRelMack';
Vue.regist(SwbMerchtDevcDefRelMack);

// 组装件定义选择
export function showMerchtDevcDefRelMackDlg(params, callback) {
    let asmblIds = params["asmblIds"] || [];
    let deviceIds = params["deviceIds"] || [];
    let asmblFilter = params["asmblFilter"] || {};
    let deviceFilter = params["deviceFilter"] || {};
    let theDlg = Vue.$showDialog({
        title: "资产定义关联组装件",
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-mercht-devc-def-rel-mack :asmblIds="asmblIds" :asmblFilter="asmblFilter" :deviceFilter="deviceFilter" :deviceIds="deviceIds" ref="swb_mercht_devc_def_rel_mack"></swb-mercht-devc-def-rel-mack>',
        data: {
            asmblIds: asmblIds,
            asmblFilter: asmblFilter,
            deviceFilter: deviceFilter,
            deviceIds: deviceIds
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_mercht_devc_def_rel_mack.getDlgResult() || {};
            if(result.type == 'info') {
                let postData = result.data;
                callback(postData, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbAsmblAccDefList from './AsmblAccDefList';
Vue.regist(SwbAsmblAccDefList);
// 查看组装件列表
export function showAsmblAccDefViewDlg(params) {
    let ids = params["ids"] || [];
    let title = params["title"];
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        cancelVisible: true,
        cancelText: "关闭",
        okVisible: false,
        template: '<swb-asmbl-acc-def-list :ids="ids" :viewFlag="viewFlag" ref="swb_asmbl_acc_def_list"></swb-asmbl-acc-def-list>',
        data: {
            ids: ids,
            viewFlag: true
        },
        okClicked: function () {
        }
    });
}

import SwbMerchtDevcAccAsmblRelList from './MerchtDevcAccAsmblRelList';
Vue.regist(SwbMerchtDevcAccAsmblRelList);
// 查看组装件列表
export function showMerchtDevcAccAsmblRelListDlg(params) {
    let filter = params["filter"] || {};
    let title = params["title"] || '资产定义 - 已关联组装件';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        cancelVisible: true,
        cancelText: "关闭",
        okVisible: false,
        template: '<swb-mercht-devc-acc-asmbl-rel-list :filter="filter" ref="swb_mercht_devc_acc_asmbl_rel_list"></swb-mercht-devc-acc-asmbl-rel-list>',
        data: {
            filter: filter
        },
        okClicked: function () {
        }
    });
}

import SwbShopAsmblAccIoRecSelect from './ShopAsmblAccIoRecSelect';
Vue.regist(SwbShopAsmblAccIoRecSelect);

// 组装件库存选择
export function showAsmblAccStockSelectDlg(params, callback) {
    let filter = params["filter"] || {};
    // let checkBox = params["checkBox"] == null ? true : params["checkBox"];
    let theDlg = Vue.$showDialog({
        title: "组装件 - 选择",
        width: -500,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-shop-asmbl-acc-io-rec-select :filter="filter" ref="swb_shop_asmbl_acc_io_rec_select"></swb-shop-asmbl-acc-io-rec-select>',
        data: {
            filter: filter,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_shop_asmbl_acc_io_rec_select.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbShopAsmblAccIoRecSet from './ShopAsmblAccIoRecSet';
Vue.regist(SwbShopAsmblAccIoRecSet);

// 组装件使用
export function showAsmblAccStockSetSelectDlg(params, callback) {
    let shopDevcId = params["shopDevcId"] || null;
    let onlyRead = params["onlyRead"] == null ? false : params["onlyRead"];
    let title = onlyRead ? '组装信息' : '组装件 - 选择';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 800,
        cancelVisible: true,
        okVisible: !onlyRead,
        cancelText: onlyRead ? '关闭' : '取消',
        template: '<swb-shop-asmbl-acc-io-rec-set :shopDevcId="shopDevcId" :onlyRead="onlyRead" ref="swb_shop_asmbl_acc_io_rec_set"></swb-shop-asmbl-acc-io-rec-set>',
        data: {
            shopDevcId: shopDevcId,
            onlyRead: onlyRead
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_shop_asmbl_acc_io_rec_set.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbShopAsmblAccIoRecListForSelect from './ShopAsmblAccIoRecListForSelect';
Vue.regist(SwbShopAsmblAccIoRecListForSelect);

// 待用组装件选择
export function showShopAsmblAccIoRecListForSelectDlg(params, callback) {
    let comId = params['comId'] || null;
    let checkBox = params['checkBox'] == null ? true : Utils.isTrue(params['checkBox']);
    let selectIds = params['selectIds'] || [];
    let theDlg = Vue.$showDialog({
        title: "待用组装件 - 选择",
        width: 1300,
        height: 800,
        showCloseBtn: true,
        template: '<swb-shop-asmbl-acc-io-rec-list-for-select :comId="comId" :checkBox="checkBox" :selectIds="selectIds" ref="swb_shop_asmbl_acc_io_rec_list_for_select"></swb-shop-asmbl-acc-io-rec-list-for-select>',
        data: {
            comId: comId,
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_shop_asmbl_acc_io_rec_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

import SwbAsmblAccDefSave from './AsmblAccDefSave';
Vue.regist(SwbAsmblAccDefSave);
// 资产定义保存
export function openAccDefSaveDlg(dlgConfig, callback) {
    let id = dlgConfig['id'];
    let buildFlag = dlgConfig['buildFlag'] != null ? dlgConfig['buildFlag'] : false;
    let row = dlgConfig['row'];
    let realDevcDef = dlgConfig['realDevcDef'];
    let title = Utils.isNoB(id) ? "组装件定义 - 新增" : "组装件定义 - 编辑";
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: 850,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-asmbl-acc-def-save :realDevcDef="realDevcDef" :defId="defId"  :row="row" :buildFlag="buildFlag" ref="swb_asmbl_acc_def_save"></swb-asmbl-acc-def-save>' +
        '</div>',
        data: {
            defId: id,
            row: row,
            buildFlag: buildFlag,
            realDevcDef: realDevcDef
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asmbl_acc_def_save.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let devcDef = result.data;
                    //
                    callback(devcDef, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbAsmblAccDefImpCheck from './AsmblAccDefImpCheck';
Vue.regist(SwbAsmblAccDefImpCheck);
// 组装件定义导入检查
export function openAsmblAccDefImpCheckDlg(fileObj, callback) {
    let theDlg = Vue.$showDialog({
        title: "组装件定义导入 - 检查",
        width: -100,
        height: -150,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-asmbl-acc-def-imp-check @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_asmbl_acc_def_imp_check"></swb-asmbl-acc-def-imp-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose(){
                callback({
                    importStatis: null
                });
                theDlg.close();
            }
        },
        okClicked: function () {
        },
        cancelClicked: function () {
        }
    });
}

import SwbAsmblAccDefFormatExpl from './AsmblAccDefFormatExpl';
Vue.regist(SwbAsmblAccDefFormatExpl);
// 组装件定义导入说明
export function openAsmblAccDefFormatExplDlg() {
    let theDlg = Vue.$showDialog({
        title: "组装件定义导入说明 - 查看",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-asmbl-acc-def-format-expl ref="swb_asmbl_acc_def_format_expl"></swb-asmbl-acc-def-format-expl>' +
        '</div>',
        data: {},
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbAsmblAccRelAsset from './AsmblAccRelAsset';
Vue.regist(SwbAsmblAccRelAsset);
// 待用组装件入账关联
export function openAsmblAccRelAssetDlg(params, callback) {
    let mgmtSmlAreaId = params['mgmtSmlAreaId'] || null;
    let comId = params['comId'] || null;
    let comLevel = params['comLevel'] || null;
    let includeSubComs = Utils.isTrue(params['includeSubComs']);
    let theDlg = Vue.$showDialog({
        title: "待用组装件 - 入账关联",
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-asmbl-acc-rel-asset :mgmtSmlAreaId="mgmtSmlAreaId" :comId="comId" :comLevel="comLevel" :includeSubComs="includeSubComs" ref="swb_asmbl_acc_rel_asset"></swb-asmbl-acc-rel-asset>',
        data: {
            mgmtSmlAreaId: mgmtSmlAreaId,
            comId: comId,
            comLevel: comLevel,
            includeSubComs: includeSubComs

        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asmbl_acc_rel_asset.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    let assetList = result.data || [];
                    //
                    callback(assetList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}




//////////////////
// WEBPACK FOOTER
// ./src/compo/asmblAcc/dialog.js
// module id = 57
// module chunks = 0